<template>
  <div>
    <div class="h-40 flex a-center j-center">
      <span class="fs-16 bold">选择客服</span>
    </div>
    <div class="p-v-10 p-h-20" style="min-height: 400px">
      <RadioGroup @on-change="selectionsChange" class="w-full"
                  v-model="selectId">
        <Table :columns="columns" :data="dataList" :height="tableHeight"
               @on-row-click="rowClick">
          <template slot="selectColumns" slot-scope="{ row }">
            <div class="flex a-center j-center h-full selModal" style="height: 48px">
              <Radio :key="row.roleId" :label="row.roleId">
                <span></span>
              </Radio>
            </div>
          </template>
        </Table>
      </RadioGroup>
      <div style="padding-top: 10px">
        <Page :current.sync="tablePage.currentPage" :page-size="tablePage.pageSize" :page-size-opts="pageSizeOpts"
              :show-total="true"
              :total="tablePage.total" @on-change="onPageChange" @on-page-size-change="onPageSizeChange"
              show-sizer></Page>
      </div>
    </div>
    <div class="h-50 flex a-top j-center">
      <Button @click="onCancelClick" class="m-r-15" style="width: 100px">取消</Button>
      <Button @click="onOkClick" class="m-l-15" style="width: 100px" type="primary">确定</Button>
    </div>
  </div>
</template>

<script>
import mixin from '../../../../config/mixinfile'
import {mapActions} from 'vuex'

export default {
  name: 'ServiceChooseWidget',
  mixins: [mixin.mixin],
  props: {
    open: Boolean
  },
  data () {
    return {
      tablePage: {                               //表格分页
        total: 0,
        currentPage: 1,
        pageSize: 30,
      },
      selectId: 0,
      selectName: '',
      selectlogo:'',
      columns: [
        {
          title: '选择',
          align: 'center',
          slot: 'selectColumns',
          width: 80,
        },
        {
          title: '用户编号',
          align: 'left',
          key: 'roleSerial',
          width: 140,
        },
        {
          title: '姓名',
          key: 'name',
          width: 140,
          tooltip: true
        }, {
          //   title: '登陆账号',
          //   key: 'phone',
          //   width: 200,
          //   align: 'center',
          //   tooltip: true
          // }, {
          title: '权限',
          key: 'role',
          width: 160,
        }, {title: '  ',}
      ],
      dataList: [],
      title: '',
      tableHeight: 520,
    }
  },
  watch: {
    open: {
      handler (newValue) {
        if (newValue) {
          this.tablePage.currentPage = 1
          this.selectId = 0
          this.selectName = ''
          this.selectlogo = ''
          this.dataList = []
          this.onGetGoods()
        } else {
          this.selectionMaps.clear()
        }
      },
      immediate: true
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    },
    onGetGoods () {
      let params = {
        pageNum: this.tablePage.currentPage,
        pageSize: this.tablePage.pageSize,
        type: 4
      }
      if (this.title) {
        params.name = this.title
      }
      this.getRoleList(params).then(res => {
        if (res.code === 0) {
          this.dataList = res.data.list.map(child => {
              child.role = this.getRole(child.roleType)
              return child
            }
          )
          this.tablePage.total = res.data.total || 0
        }
      })

    },
    getRole (type) {
      let roleName = ''
      switch (type) {
        case 1:
          roleName = '超级管理员'
          break
        case 2:
          roleName = '管理员'
          break
        case 3:
          roleName = '普通用户'
          break
        case 4:
          roleName = '客服'
          break
      }
      return roleName
    },
    selectionsChange (selection) {
      this.selectName = ''
      this.selectlogo = ''
      let item = this.dataList.find(e => {
        return e.roleId === selection
      })
      if (item) {
        this.selectName = item.name
        this.selectlogo = item.logo
      }
    },
    rowClick (row) {
      this.selectId = row.roleId
      this.selectionsChange(row.roleId)
    },
    /**
     * 分页请求
     * @param e
     */
    onPageChange (e) {
      this.tablePage.currentPage = e
      this.onGetGoods()
    },
    /**
     * 换页条数请求处理
     * @param e
     */
    onPageSizeChange (e) {
      this.tablePage.pageSize = e
      if (this.tablePage.currentPage === 1) {
        this.onGetGoods()
      }
    },
    onCancelClick () {
      this.$emit('cancel')
    },
    onOkClick () {
      let list = [{
        id: this.selectId,
        name: this.selectName,
        logo:this.selectlogo
      }]
      this.$emit('ok', list)
    },
    ...mapActions([
      'getRoleList',
    ])
  },
}
</script>

<style lang="scss" scoped>

</style>
